import { LEARNING_STATISTICS_CONTENT, LEARNING_STATISTICS_MODE } from './constants.ts';
import type { LearningStatisticsMode } from './types.ts';

export const getLearningStatisticsContent = (mode: LearningStatisticsMode) => {
    return LEARNING_STATISTICS_CONTENT[mode] ?? LEARNING_STATISTICS_CONTENT[LEARNING_STATISTICS_MODE.LEARNER];
};

const BAR_LABEL_OPTIONS = {
    show: true,
    position: 'top',
    formatter: (p: any) => (p.value > 0 ? p.value : ''),
} as const;

interface CreateBarSeriesParams {
    name: string;
    data: any[];
    color: string;
    stack?: string;
    barGap?: number;
}

export const createBarSeries = ({ name, data, color, stack, barGap }: CreateBarSeriesParams) => ({
    name,
    type: 'bar',
    ...(stack ? { stack } : {}),
    data,
    barWidth: '21%',
    ...(barGap !== undefined ? { barGap } : {}),
    itemStyle: {
        color,
    },
    label: BAR_LABEL_OPTIONS,
});
